<div class="container-fluid">
  @if (showDesign) {
    <div class="row">
      <div class="col-12">
        <button class="btn btn-link" type="button" (click)="backButton()">Back</button>
      </div>
    </div>
  }

  <div class="row">
    <div class="col-12">
      <h3 class="text-center" style="margin-top: 10px">Theme</h3>
    </div>
  </div>

  @if (themeName !== '' && themeName) {
    <div class="row" style="margin-top: 20px">
      <div class="col-12">
        @if (themeName === 'purple0011-0022') {
          <h6>Current Theme: Lavender</h6>
        }
        @if (themeName === 'royal0011-0022') {
          <h6>Current Theme: Royal Blue</h6>
        }
        @if (themeName === 'lightblue0011-0022') {
          <h6>Current Theme: Light Blue</h6>
        }
        @if (themeName === 'olivegreen0011-0022') {
          <h6>Current Theme: Olive Green</h6>
        }
        @if (themeName === 'lightgreen0011-0022') {
          <h6>Current Theme: Light Green</h6>
        }
        @if (themeName === 'orange0011-0022') {
          <h6>Current Theme: Orange</h6>
        }
        @if (themeName === 'red0011-0022') {
          <h6>Current Theme: Red</h6>
        }
        @if (themeName === 'pink0011-0022') {
          <h6>Current Theme: Pink</h6>
        }
        @if (themeName === 'brown0011-0022') {
          <h6>Current Theme: Brown</h6>
        }
        @if (themeName === 'bluegrey0011-0022') {
          <h6>Current Theme: Blue Gray</h6>
        }
        @if (
          themeName !== 'royal0011-0022' &&
          themeName !== 'purple0011-0022' &&
          themeName !== 'lightblue0011-0022' &&
          themeName !== 'olivegreen0011-0022' &&
          themeName !== 'lightgreen0011-0022' &&
          themeName !== 'orange0011-0022' &&
          themeName !== 'red0011-0022' &&
          themeName !== 'pink0011-0022' &&
          themeName !== 'brown0011-0022' &&
          themeName !== 'bluegrey0011-0022'
        ) {
          <h6>Current Theme: {{ themeName }}</h6>
        }
      </div>
    </div>
  }

  @if (!showDesign) {
    <div class="row">
      <div class="col-12 cust-new-theme">
        <button class="btn btn-primary" type="button" (click)="customizeTheme()">New theme</button>
      </div>
      <div class="col-12 or-use">OR</div>
      <div class="col-12">
        @if (themes.length === 0) {
          <div class="nav-search-index d-flex">
            <!-- <h6 style="width:90px">Available Themes:</h6> -->
            <div class="d-flex">
              <select
                title="Select Search Index"
                (change)="selectOption($event)"
                [(ngModel)]="selectDefault"
              >
                <option value="None">None</option>
                <option value="None">Pick a Theme</option>
                <option value="Lavender">Lavender</option>
                <option value="LBlue">Light Blue</option>
                <option value="RBlue">Royal Blue</option>
                <option value="LGreen">Light Green</option>
                <option value="OGreen">Olive Green</option>
                <option value="Orange">Orange</option>
                <option value="Pink">Pink</option>
                <option value="Red">Red</option>
                <option value="Brown">Brown</option>
                <option value="BGray">Blue Gray</option>
              </select>
            </div>
            <div class="d-flex">
              @if (isShowApply) {
                <i
                  class="fa fa-lg fa-floppy-o margin-top"
                  aria-hidden="true"
                  title="apply theme"
                  style="margin-left: 10px !important; cursor: pointer"
                  (click)="applyTheme()"
                ></i>
              }
            </div>
          </div>
        }
        @if (themes.length > 0) {
          <div class="nav-search-index d-flex">
            <!-- <h6 style="width:90px">Available Themes:</h6> -->
            <div class="d-flex" style="margin-right: 10px">
              <select
                title="Select Search Index"
                (change)="selectOption($event)"
                [(ngModel)]="selectDefault"
              >
                <option value="None">Pick a Theme</option>
                <option value="Lavender">Lavender</option>
                <option value="LBlue">Light Blue</option>
                <option value="RBlue">Royal Blue</option>
                <option value="LGreen">Light Green</option>
                <option value="OGreen">Olive Green</option>
                <option value="Orange">Orange</option>
                <option value="Pink">Pink</option>
                <option value="Red">Red</option>
                <option value="Brown">Brown</option>
                <option value="BGray">Blue Gray</option>
                <!-- loop through other options here -->
                @for (item of themes; track item) {
                  <option [value]="item._id">
                    @if (item?.themeName === 'purple0011-0022') {
                      <span>Lavendar</span>
                    }
                    @if (item?.themeName === 'royal0011-0022') {
                      <span>Royak Blue</span>
                    }
                    @if (item?.themeName === 'lightblue0011-0022') {
                      <span>Light Blue</span>
                    }
                    @if (item?.themeName === 'olivegreen0011-0022') {
                      <span>Olive Green</span>
                    }
                    @if (item?.themeName === 'lightgreen0011-0022') {
                      <span>Light Green</span>
                    }
                    @if (item?.themeName === 'orange0011-0022') {
                      <span>Orange</span>
                    }
                    @if (item?.themeName === 'red0011-0022') {
                      <span>Red</span>
                    }
                    @if (item?.themeName === 'pink0011-0022') {
                      <span>Pink</span>
                    }
                    @if (item?.themeName === 'brown0011-0022') {
                      <span>Brown</span>
                    }
                    @if (item?.themeName === 'bluegrey0011-0022') {
                      <span>Blue Gray</span>
                    }
                    @if (
                      item?.themeName !== 'purple0011-0022' &&
                      item?.themeName !== 'royal0011-0022' &&
                      item?.themeName !== 'lightblue0011-0022' &&
                      item?.themeName !== 'olivegreen0011-0022' &&
                      item?.themeName !== 'lightgreen0011-0022' &&
                      item?.themeName !== 'orange0011-0022' &&
                      item?.themeName !== 'red0011-0022' &&
                      item?.themeName !== 'pink0011-0022' &&
                      item?.themeName !== 'brown0011-0022' &&
                      item?.themeName !== 'bluegrey0011-0022'
                    ) {
                      <span>{{ item?.themeName }}</span>
                    }
                    <span></span>
                  </option>
                }
              </select>
            </div>
            <div class="d-flex">
              @if (isShowEdit) {
                <i
                  class="fa fa-lg fa-pencil-square-o margin-top"
                  aria-hidden="true"
                  title="edit theme"
                  (click)="editTheme()"
                  style="cursor: pointer"
                ></i>
              }
            </div>
            <div class="d-flex">
              @if (isShowApply) {
                <i
                  class="fa fa-lg fa-floppy-o margin-top"
                  aria-hidden="true"
                  title="apply theme"
                  (click)="applyTheme()"
                  style="cursor: pointer"
                ></i>
              }
            </div>
            <div class="d-flex">
              @if (isShowDelete) {
                <i
                  class="fa fa-lg fa-trash margin-top"
                  aria-hidden="true"
                  title="delete theme"
                  (click)="deleteTheme()"
                  style="cursor: pointer"
                ></i>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>

@if (showDesign) {
  <h6 class="text-start margin-5-0 pointer" style="margin-left: 30px">
    Themes & Customize Settings
  </h6>
}
@if (showDesign) {
  <div class="relative margin-15-0 padding-0-25">
    <button
      role="button"
      type="button"
      aria-label="Set Purple"
      class="btn btn-circle"
      style="margin-bottom: 5px"
      title="Lavender"
      [style.background]="colorPurple"
      (click)="setPurple()"
    ></button>
    <button
      role="button"
      type="button"
      aria-label="Set Light Blue"
      class="btn btn-circle"
      style="margin-bottom: 5px"
      title="Light Blue"
      [style.background]="colorLightBlue"
      (click)="setLightBlue()"
    ></button>
    <button
      role="button"
      type="button"
      aria-label="Set Royal"
      class="btn btn-circle"
      style="margin-bottom: 5px"
      title="Royal Blue"
      [style.background]="colorRoyal"
      (click)="setRoyal()"
    ></button>
    <button
      role="button"
      type="button"
      aria-label="Set Light Green"
      class="btn btn-circle"
      style="margin-bottom: 5px"
      title="Light Green"
      [style.background]="colorLightGreen"
      (click)="setLightGreen()"
    ></button>
    <button
      role="button"
      type="button"
      aria-label="Set Green"
      class="btn btn-circle"
      style="margin-bottom: 5px"
      title="Olive Green"
      [style.background]="colorGreen"
      (click)="setGreen()"
    ></button>
    <button
      role="button"
      type="button"
      aria-label="Set Orange"
      class="btn btn-circle"
      style="margin-bottom: 5px"
      title="Orange"
      [style.background]="colorOrange"
      (click)="setOrange()"
    ></button>
    <button
      role="button"
      type="button"
      aria-label="Set Pink"
      class="btn btn-circle"
      style="margin-bottom: 5px"
      title="Pink"
      [style.background]="colorPink"
      (click)="setPink()"
    ></button>
    <button
      role="button"
      type="button"
      aria-label="Set Red"
      class="btn btn-circle"
      style="margin-bottom: 5px"
      title="Red"
      [style.background]="colorRed"
      (click)="setRed()"
    ></button>
    <button
      role="button"
      type="button"
      aria-label="Set Brown"
      class="btn btn-circle"
      style="margin-bottom: 5px"
      title="Brown"
      [style.background]="colorBrown"
      (click)="setBrown()"
    ></button>
    <button
      role="button"
      type="button"
      aria-label="Set Blue Grey"
      class="btn btn-circle"
      style="margin-bottom: 5px"
      title="Blue Grey"
      [style.background]="colorBlueGrey"
      (click)="setBlueGrey()"
    ></button>
  </div>
}

@if (showDesign) {
  <div class="relative margin-15-0 padding-0-50" style="padding-left: 33px !important">
    <h6>Theme Name:</h6>
    <input type="text" style="margin-bottom: 10px" [(ngModel)]="themeName" />
    <h6>Header</h6>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="color"
        aria-describedby="Font and Icon Color"
        placeholder="header foreground"
        title="header foreground"
        (input)="setCustomColor('--header-color', $any($event).target.value)"
        [(ngModel)]="headerColor"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="headerColor"
        [(colorPicker)]="headerColor"
        (colorPickerChange)="setCustomColor('--header-color', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="header foreground text and quicklinks text color"
      ></i>
    </div>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="color"
        aria-describedby="Background Color"
        placeholder="header background"
        title="header background"
        (input)="setCustomColor('--header-background', $any($event).target.value)"
        [(ngModel)]="headerBackground"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="headerBackground"
        [(colorPicker)]="headerBackground"
        (colorPickerChange)="setCustomColor('--header-background', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="header background"
      ></i>
    </div>
    <h6>Footer</h6>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="color"
        aria-describedby="Font and Icon Color"
        placeholder="footer foreground"
        title="footer foreground"
        (input)="setCustomColor('--footer-color', $any($event).target.value)"
        [(ngModel)]="footerColor"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="footerColor"
        [(colorPicker)]="footerColor"
        (colorPickerChange)="setCustomColor('--footer-color', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="footer foreground"
      ></i>
    </div>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="color"
        aria-describedby="Background Color"
        placeholder="footer background"
        title="header background"
        (input)="setCustomColor('--footer-background', $any($event).target.value)"
        [(ngModel)]="footerBackground"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="footerBackground"
        [(colorPicker)]="footerBackground"
        (colorPickerChange)="setCustomColor('--footer-background', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="footer background"
      ></i>
    </div>
    <h6>Body</h6>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="color"
        aria-describedby="Font and Icon Color"
        placeholder="body foreground"
        title="body foreground"
        (input)="setCustomColor('--body-color', $any($event).target.value)"
        [(ngModel)]="bodyColor"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="bodyColor"
        [(colorPicker)]="bodyColor"
        (colorPickerChange)="setCustomColor('--body-color', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="body foreground"
      ></i>
    </div>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="color"
        aria-describedby="Background Color"
        placeholder="body background"
        title="body background"
        (input)="setCustomColor('--body-background', $any($event).target.value)"
        [(ngModel)]="bodyBackground"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="bodyBackground"
        [(colorPicker)]="bodyBackground"
        (colorPickerChange)="setCustomColor('--body-background', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="body background"
      ></i>
    </div>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="color"
        aria-describedby="Hyperlink"
        placeholder="Active Links"
        title="active links"
        (input)="setCustomColor('--link', $any($event).target.value)"
        [(ngModel)]="link"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="link"
        [(colorPicker)]="link"
        (colorPickerChange)="setCustomColor('--link', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="active links"
      ></i>
    </div>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="color"
        aria-describedby="Hover and Focus on Hyperlink"
        placeholder="Hover and Focus"
        title="hover and focus"
        (input)="setCustomColor('--hover-focus', $any($event).target.value)"
        [(ngModel)]="hoverFocus"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="hoverFocus"
        [(colorPicker)]="hoverFocus"
        (colorPickerChange)="setCustomColor('--hover-focus', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="hover and focus"
      ></i>
    </div>
    <h6>Button</h6>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="color"
        aria-describedby="Font and Icon Color"
        placeholder="Color"
        title="button color"
        (input)="setCustomColor('--button-color', $any($event).target.value)"
        [(ngModel)]="buttonColor"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="buttonColor"
        [(colorPicker)]="buttonColor"
        (colorPickerChange)="setCustomColor('--button-color', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="button color"
      ></i>
    </div>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="color"
        aria-describedby="Background Color"
        placeholder="Background"
        title="button background"
        (input)="setCustomColor('--button-background', $any($event).target.value)"
        [(ngModel)]="buttonBackground"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="buttonBackground"
        [(colorPicker)]="buttonBackground"
        (colorPickerChange)="setCustomColor('--button-background', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="button background"
      ></i>
    </div>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="color"
        aria-describedby="Background Color"
        placeholder="Border"
        title="button border"
        (input)="setCustomColor('--button-border', $any($event).target.value)"
        [(ngModel)]="buttonBorder"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="buttonBorder"
        [(colorPicker)]="buttonBorder"
        (colorPickerChange)="setCustomColor('--button-border', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="button border"
      ></i>
    </div>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="neutral"
        title="neutral"
        aria-describedby="Base Shade"
        placeholder="neutral"
        (input)="setCustomColor('--neutral', $any($event).target.value)"
        [(ngModel)]="neutral"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="neutral"
        [(colorPicker)]="neutral"
        (colorPickerChange)="setCustomColor('--neutral', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="neutral color"
      ></i>
    </div>
    <h6>Content Background Color</h6>
    <!-- OFFSETS -->
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="offsetOne"
        title="offset one"
        (input)="setCustomColor('--offset-one', $any($event).target.value)"
        aria-describedby="Offset One"
        placeholder="offset one"
        [(ngModel)]="offsetOne"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="offsetOne"
        [(colorPicker)]="offsetOne"
        (colorPickerChange)="setCustomColor('--offset-one', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="Visible on header, staff dashboard, advanced search, some buttons and dropdowns"
      ></i>
    </div>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="offsetTwo"
        title="offset two"
        aria-describedby="Offset Two"
        placeholder="offset two"
        (input)="setCustomColor('--offset-two', $any($event).target.value)"
        [(ngModel)]="offsetTwo"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="offsetTwo"
        [(colorPicker)]="offsetTwo"
        (colorPickerChange)="setCustomColor('--offset-two', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="Visible in search overlay, staff dashboard search box, search resources and advanced search resources top checkboxes, related links on search"
      ></i>
    </div>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="offsetThree"
        title="offset three"
        aria-describedby="Offset Three"
        placeholder="offset three"
        (input)="setCustomColor('--offset-three', $any($event).target.value)"
        [(ngModel)]="offsetThree"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="offsetThree"
        [(colorPicker)]="offsetThree"
        (colorPickerChange)="setCustomColor('--offset-three', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="Visible on search box background on advanced search, place hold table borders and button borders"
      ></i>
    </div>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="shadeFour"
        title="shade links"
        aria-describedby="Shade Links"
        placeholder="shade four"
        (input)="setCustomColor('--shade-four', $any($event).target.value)"
        [(ngModel)]="shadeFour"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="shadeFour"
        [(colorPicker)]="shadeFour"
        (colorPickerChange)="setCustomColor('--shade-four', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip="certain links on OPAC search"
      ></i>
    </div>
    <div class="form-group block relative row-cust-settings">
      <input
        type="text"
        class="form-control color"
        id="accentThree"
        title="toggle icon color"
        aria-describedby="toggle icon color"
        placeholder="accent three"
        (input)="setCustomColor('--accent-three', $any($event).target.value)"
        [(ngModel)]="accentThree"
      />
      <button
        role="button"
        type="button"
        aria-label="Change Color"
        class="btn btn-circle"
        [style.background]="accentThree"
        [(colorPicker)]="accentThree"
        (colorPickerChange)="setCustomColor('--accent-three', $event)"
      ></button>
      <i
        class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
        aria-hidden="true"
        [matTooltipPosition]="'right'"
        matTooltip=" toggle view icon color on OPAC search"
      ></i>
    </div>
  </div>
}

@if (isEditTheme && showDesign) {
  <div class="width-100 margin-25-0 text-end">
    @if (showSaveButton) {
      <button
        role="button"
        type="button"
        aria-label="Save Theme"
        class="btn btn-primary"
        (click)="saveTheme()"
      >
        Save
      </button>
    }
    @if (showApplyButton) {
      <button
        role="button"
        type="button"
        aria-label="Submit"
        class="btn btn-primary"
        (click)="setColorTheme()"
      >
        Apply
      </button>
    }
  </div>
}

@if (isNewTheme && showDesign) {
  <div class="width-100 margin-25-0 text-end">
    @if (showSaveButton) {
      <button
        role="button"
        type="button"
        aria-label="Save Theme"
        class="btn btn-primary"
        (click)="saveTheme()"
      >
        Save
      </button>
    }
    @if (showApplyButton) {
      <button
        role="button"
        type="button"
        aria-label="Submit"
        class="btn btn-primary"
        (click)="setColorTheme()"
      >
        Apply
      </button>
    }
  </div>
}
